import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {getRandomColor} from "../utils/GetRandomColor";
import {useNavigate, useLocation} from 'react-router-dom';
import {useState} from "react";

export default function Button({
                                   icon,
                                   text,
                                   onClick,
                                   type,
                                   to,
                                   topMargin = false,
                               }) {

    const location = useLocation();
    const navigate = useNavigate();
    const isActive = to && location.pathname === to;

    const [backgroundColor] = useState(() =>
        to || onClick || (type === 'submit') ? getRandomColor() : "#555555"
    );

    const handleClick = () => {
        if (to) {
            navigate(to);
        } else if (onClick) {
            onClick();
        }
    };

    const styles = {
        common: {
            outline: isActive ? "5px solid #ffffff" : "none",
            border: "none",
            backgroundColor: backgroundColor,
            color: "#ffffff",
            fontWeight: "bold",
            paddingTop: "5px",
            paddingBottom: "5px",
            paddingLeft: "15px",
            paddingRight: "15px",
            cursor: to || onClick ? "pointer" : "default",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: topMargin ? "50px" : "0px",
            textAlign: "right",
        },
    }

    return (
        <button
            onClick={handleClick}
            style={styles.common}
        >
            {icon && <FontAwesomeIcon icon={icon}/>}
            {text}
        </button>
    )
}
